import React from 'react';
import { REPORT_TYPE_SET } from '../../../../config/ReportOptionSet';

import './ReportTypeOption.css';

const ReportTypeOption = (props) => {
  return (
    <div className="option_subQuery" style={{ width: '220px' }}>
      <div className="optionSetting1">
        <div className="optionSettingTit">
          분석 지표
        </div>
        {props.currentRole == "ROLE_ADMIN" ?
          <div className="subQueryLine">
            <a className="button smallOpt reportType" name="volume" onClick={(e) => props.handleReportType(e)}>{REPORT_TYPE_SET.volume}</a>
            <a className="button smallOpt reportType" name="category" onClick={(e) => props.handleReportType(e)}>{REPORT_TYPE_SET.category}</a>
            <a className="button smallOpt reportType" name="sentiment" onClick={(e) => props.handleReportType(e)}>{REPORT_TYPE_SET.sentiment}</a>
            <a className="button smallOpt reportType" name="relation" onClick={(e) => props.handleReportType(e)}>{REPORT_TYPE_SET.relation}</a>
            <a className="button smallOpt reportType" name="source" onClick={(e) => props.handleReportType(e)}>{REPORT_TYPE_SET.source}</a>
            <a className="button smallOpt reportType" name="positioningmap" onClick={(e) => props.handleReportType(e)}>{REPORT_TYPE_SET.positioningmap}</a>
            <a className="button smallOpt reportType" name="buzzlist" onClick={(e) => props.handleReportType(e)}>{REPORT_TYPE_SET.buzzlist}</a>
            <a className="button smallOpt reportType" name="emotion" onClick={(e) => props.handleReportType(e)}>{REPORT_TYPE_SET.emotion}</a>
            <a className="button smallOpt reportType" name="channel_buzzlist" onClick={(e) => props.handleReportType(e)}>{REPORT_TYPE_SET.channel_buzzlist}</a>
          </div>
          : <div className="subQueryLine">
            <a className="button smallOpt reportType" name="volume" onClick={(e) => props.handleReportType(e)}>{REPORT_TYPE_SET.volume}</a>
            <a className="button smallOpt reportType" name="category" onClick={(e) => props.handleReportType(e)}>{REPORT_TYPE_SET.category}</a>
            <a className="button smallOpt reportType" name="sentiment" onClick={(e) => props.handleReportType(e)}>{REPORT_TYPE_SET.sentiment}</a>
            <a className="button smallOpt reportType" name="relation" onClick={(e) => props.handleReportType(e)}>{REPORT_TYPE_SET.relation}</a>
            <a className="button smallOpt reportType" name="source" onClick={(e) => props.handleReportType(e)}>{REPORT_TYPE_SET.source}</a>
            <a className="button smallOpt reportType" name="positioningmap" onClick={(e) => props.handleReportType(e)}>{REPORT_TYPE_SET.positioningmap}</a>
            <a className="button smallOpt reportType" name="buzzlist" onClick={(e) => props.handleReportType(e)}>{REPORT_TYPE_SET.buzzlist}</a>
          </div>
        }

      </div>
    </div>
  )
}

export default ReportTypeOption;